import React from 'react'
import ReactDOM from 'react-dom'

export default class TimeEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {value: this.transformSecondsToString(props.value)}
  }

  handleChange = (e) => {
    this.setState({value: e.target.value})
  }

  getValue = () => {
    const regex = new RegExp('([0-9]*):([0-9]*)')
    const matches = this.state.value.match(regex)
    let seconds = this.state.value
    if (matches.length > 2) {
      seconds = Number(matches[1]) * 60 + Number(matches[2])
    }
    console.log(seconds)
    return {
      [this.props.column.key]: seconds
    }
  }

  getEditorDisplayValue = () =>  {
    return this.state.value
  }

  transformSecondsToString = (value) => {
    let seconds = Number(value)
    const minutes = Math.floor(seconds / 60)
    seconds = seconds % 60
    return `${minutes}:${seconds}`
  }

  handleBlur = () => {
    this.props.onCommit()
  }

  getInputNode = () => {
      return ReactDOM.findDOMNode(this).getElementsByTagName('input')[0];
  }

  render() {
    let label = this.props.label != null ? this.props.label : 'title';
    return (<div height={this.props.height} onKeyDown={this.props.onKeyDown}>
      <input type="text" label={label} onChange={this.handleChange} onFocus={this.props.onFocus} value={this.getEditorDisplayValue()} />
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/TimeEditor.js